<template>
  <base-form
    :disabled="
      ['002', '004', '005', '006', '007', '008'].indexOf(formData.statusFlag) != -1 || !canEdit
    "
    v-model="formData"
    :options="options"
    ref="topData"
    :rules="rules"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import DictSelect from '@/components/DictSelect';
  import BASE_API from '@/api/dataBase';
  // import SearchModal from '@/components/SearchModal';
  // import API from '@/api/capitalCenter/letterOfCredit';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import AGENCY_API from '@/api/agencyContract/index';
  import BaseForm from '@/components/form/base-form';
  import XEUtils from 'xe-utils';
  export default {
    name: 'applicationForm',
    components: {
      // SearchTable,
      // SearchModal,
      // InputNumber,
      // ajaxSelect,
      // DictSelect,
      BaseForm,
    },
    props: ['type', 'canEdit'],
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        formData: {
          sourceType: '1', // 1-开证 2-收证
          businessCompanyCode: '', // 公司编码收证公司编码
          businessCompanyName: '', // 公司名收证公司名称
          businessDepartmentCode: '', // 业务部门编码收证业务部门编码
          businessDepartmentName: '', // 业务部门名收证业务部门名
          applyNo: '', // 申请单号
          applyDate: date, // 申请日期
          applyUserId: '', // 申请人ID
          applyUserName: '', // 申请人名称
          exchangeType: 'Cooperate', // 汇率类型(字典)
          applyExchangeRate: '', // 汇率
          applyExchangeRateDate: date, // 汇率日期
          currencyCode: '', // 币种编码
          currencyName: '', // 币种名称
          applyClAmount: '', // 申请的开证金额
          applyClStandardAmount: '', // 申请的开证本位币金额
          statusFlag: '', // 信用证状态
          partnerCode: '', // 存的合作伙伴编码收证时，存开证申请人
          partnerName: '', // 存的合作伙伴名称收证时，存开证申请人
          clType: '', // 信用证类别收证同
          clValidDate: '', // 信用证有效日期
          importExportNature: '', // 经营性质
          acceptanceAmount: 0, // 已承兑金额 开证收证均有
          shipmentPlace: '', // 起运港
          destinationPlace: '', // 目的港
          overShortShippedPercentage: 0, // 溢短装比例收证时也有
          clAttr: '003', // 信用证属性 开证收证都有
          paidAmount: 0, // 已付款金额 开证收证时存的是已收款金额
          latestShipDate: '', // 最迟装期 开证收证
          estimatedArrivalDate: '', // 预计到港日
          estimatedPayDate: '', // 预计付汇日
          clNature: '', // 信用证性质 开证收证
          usanceDaysNumber: 0, // 远期天数 开证收证
          applyBranchCode: '', // 申请的开证银行代码
          applyBranchName: '', // 申请的开证银行名称
          applyBankAccountNum: '', // 申请的开证银行账户号码
          payCondition: '', // 付款条件 开证收证
          presentationPeriod: '', // 交单期 手工输入对应的天数
          businessNature: '', // 业务性质
          applyMarginAmount: '', // 申请的银行保证金金额
          issueCost: '', // 开证费用
          acceptanceCost: '', // 承兑费用
          accountStatus: null, // 入账状态 0-未入账,其他状态待确认
          accountDate: '', // 入账日期
          voucherCode: '', // 凭证编号
          summary: '', // 摘要,以上是申请信息
          clCode: '', // 以下是开证信息 信用证号收证同
          issueDate: '', // 开证日期
          issueType: '', // 开证类型
          marginRate: '', // 银行保证金比率
          marginAmount: '', // 银行保证金金额
          marginCurrencyCode: '', // 保证金币种编码
          marginCurrencyName: '', // 保证币种名称
          marginPayDate: '', // 保证金支付日期
          marginExchangeType: '', // 保证金汇率类型(字典)
          marginExchangeRate: '', // 保证金汇率
          marginExchangeRateDate: '', // 保证金汇率日期
          marginStandardAmount: '', // 银行保证金本币金额
          marginPayAccount: '', // 保证金付款银行账户
          branchCode: '', // 银行代码收证时开证银行代码
          bankBranch: '', // 银行名称收证时开证银行名称
          payBranchCode: '', // 付款行代码 收证时付款行银行代码
          payBranchName: '', // 付款银行名称 收证时付款银行名称
          notifyingBranchCode: '', // 通知行代码 收证时通知行银行代码
          notifyingBranchName: '', // 通知行名称 收证时通知行银行名称
          negotiationBranchCode: '', // 议付行代码 收证时议付行代码
          negotiationBranchName: '', // 议付行名称 收证时议付行名称
          receivingDate: '', // 收证时收证日期
          cashflowTransactionCode: '', // 现金流量事务代码
          isIndependent: '', // 是否独立开证1独立 0非独立
          isForeignParent: '', // 外商母证开证1是 0 否
          isRefundMargin: '', // 已退回保证金1已退 0未退
          isAccpetComplete: '', // 是否完全承兑1是 0否
          acceptCompleteDate: '', // 完全承兑日期
          isPayComplete: '', // 是否完全付款1是 0 否
          revocationDate: '', // 撤销日期

          clMarginRate: '', //开证申请开证保证金比例',
          clIssueCostRate: '', //开证申请开证费用比例',
          clAcceptanceCostRate: '', //开证申请'承兑费用比例',
          discountAfford: '', // 贴息承担方
          actualDiscountRate: '', // 实际贴现息
          forecastDiscountRate: '', // 预计贴现息
          discountDate: '', // 贴现日期
          discountRate: '', // 贴现率
        },
        departmentOptions: [],
        companyOptions: [],
        bankList: [],
        currencyCode: '', //选择币种名称
        originalCurrencyCode: '', //原始币种代码
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      options() {
        return [
          {
            type: 'select',
            options: this.companyOptions,
            label: this.$t('tFundCreditLetter.column.businessCompanyName'),
            prop: 'businessCompanyCode',
            clearable: true,
            disabled: false,
            required: true,
          }, //公司编码收证公司编码
          {
            type: 'select',
            options: this.departmentOptions,
            label: this.$t('tFundCreditLetter.column.businessDepartmentName'),
            prop: 'businessDepartmentCode',
            clearable: true,
            disabled: false,
            required: true,
          }, //业务部门编码收证业务部门编码
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.applyNo'),
            prop: 'applyNo',
            clearable: true,
            disabled: true,
          }, //申请单号
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.applyDate'),
            prop: 'applyDate',
            clearable: true,
            disabled: true,
            required: true,
          }, //申请日期
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.applyUserName'),
            prop: 'applyUserName',
            clearable: true,
            disabled: true,
          }, //申请人名称
          {
            type: 'dict',
            dictType: 'all_currency',
            valueType: 'object',
            label: this.$t('tFundCreditLetter.column.currencyCode'),
            prop: 'currencyCode',
            clearable: true,
            disabled: false,
            required: true,
          }, //币种编码
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.applyExchangeRateDate'),
            prop: 'applyExchangeRateDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //汇率日期
          {
            type: 'input',
            label: '开证申请汇率',
            prop: 'applyExchangeRate',
            clearable: true,
            disabled: this.formData.currencyCode == this.formData.companyCurrencyCode,
            required: true,
            maxlength: 20,
          }, //汇率
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.applyClAmount'),
            prop: 'applyClAmount',
            clearable: true,
            disabled: true,
            required: true,
          }, //申请的开证金额
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.applyClStandardAmount'),
            prop: 'applyClStandardAmount',
            clearable: true,
            disabled: true,
            required: true,
          }, //申请的开证本位币金额
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.statusFlag'),
            prop: 'statusFlag',
            clearable: true,
            disabled: true,
            dictType: 'cl-status-flag',
          }, //信用证状态
          {
            type: 'date',
            label: '撤销日期',
            prop: 'revocationDate',
            placeholder: '撤销后自动生成',
            clearable: true,
            disabled: true,
            required: false,
          }, //撤销日期
          {
            type: 'searchTable',
            label: this.$t('tFundCreditLetter.column.partnerCode'),
            prop: 'partnerCode',
            clearable: true,
            disabled: false,
            isMultiple: true,
            required: true,
            searchType: 'supplier',
            extraData: {
              companyCode: this.formData.businessCompanyCode,
              departmentCode: this.formData.businessDepartmentCode,
            },
            name: 'partnerName',
            code: 'partnerCode',
            getName: 'partnerZhName',
            getCode: 'partnerCode',
          }, //受益人
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.clType'),
            prop: 'clType',
            clearable: true,
            dictType: 'cl-clType',
            disabled: false,
            required: true,
          }, //信用证类别收证同
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.clValidDate'),
            prop: 'clValidDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //信用证有效日期
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.importExportNature'),
            prop: 'importExportNature',
            clearable: true,
            dictType: 'cl-importExportNature',
            disabled: false,
            required: true,
          }, //经营性质
          // {
          //   type: 'input',
          //   label: this.$t('tFundCreditLetter.column.acceptanceAmount'),
          //   prop: 'acceptanceAmount',
          //   clearable: true,
          //   disabled: true,
          //   required: false,
          // }, //已承兑金额 开证收证均有  0207版本 原型去掉
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.shipmentPlace'),
            prop: 'shipmentPlace',
            clearable: true,
            disabled: false,
            maxlength: 32,
          }, //起运港
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.destinationPlace'),
            prop: 'destinationPlace',
            clearable: true,
            disabled: false,
            maxlength: 32,
          }, //目的港
          {
            type: 'inputNumber',
            label: this.$t('tFundCreditLetter.column.overShortShippedPercentage'),
            prop: 'overShortShippedPercentage',
            clearable: true,
            disabled: false,
            required: true,
          }, //溢短装比例收证时也有
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.clAttr'),
            prop: 'clAttr',
            dictType: 'cl-clAttr',
            clearable: true,
            disabled: false,
            required: true,
          }, //信用证属性
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.paidAmount'),
            prop: 'paidAmount',
            clearable: true,
            disabled: true,
            required: true,
          }, //已付款金额 开证收证时存的是已收款金额
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.latestShipDate'),
            prop: 'latestShipDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //最迟装期 开证收证
          {
            type: 'inputNumber',
            label: this.$t('tFundCreditLetter.column.usanceDaysNumber'),
            prop: 'usanceDaysNumber',
            clearable: true,
            disabled: false,
            required: true,
          }, //远期天数 开证收证
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.estimatedPayDate'),
            prop: 'estimatedPayDate',
            clearable: true,
            disabled: false,
          }, //预计付汇日
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.estimatedArrivalDate'),
            prop: 'estimatedArrivalDate',
            clearable: true,
            disabled: false,
          }, //预计到港日
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.clNature'),
            prop: 'clNature',
            dictType: 'cl-clNature',
            clearable: true,
            disabled: false,
            required: true,
          }, //信用证性质 开证收证
          {
            type: 'searchTable',
            label: this.$t('tFundCreditLetter.column.applyBranchCode'),
            prop: 'applyBranchCode',
            clearable: true,
            disabled: false,
            isMultiple: true,
            required: true,
            searchType: 'bankAccountBranchName',
            extraData: { companyCode: this.formData.businessCompanyCode },
            currentValue: this.formData.applyBranchName,
          }, //开证银行
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.payCondition'),
            prop: 'payCondition',
            clearable: true,
            dictType: 'receipt_condition',
            disabled: false,
          }, //付款条件 开证收证
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.presentationPeriod'),
            prop: 'presentationPeriod',
            clearable: true,
            disabled: false,
          }, //交单期限/天
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.businessNature'),
            prop: 'businessNature',
            clearable: true,
            dictType: 'cl-businessNature',
            disabled: false,
            required: true,
          }, //业务性质
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.applyMarginAmount'),
            prop: 'applyMarginAmount',
            clearable: true,
            disabled: true,
          }, //申请的银行保证金金额
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.issueCost'),
            prop: 'issueCost',
            clearable: true,
            disabled: true,
            maxlength: 20,
          }, //开证费用
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.acceptanceCost'),
            prop: 'acceptanceCost',
            clearable: true,
            disabled: true,
            maxlength: 20,
          }, //承兑费用
          // {
          //   type: 'dict',
          //   label: this.$t('tFundCreditLetter.column.accountStatus'),
          //   prop: 'accountStatus',
          //   clearable: true,
          //   dictType: 'post_status',
          //   disabled: true,
          // }, //入账状态
          {
            type: 'input',
            label: '贴现率',
            prop: 'discountRate',
            clearable: true,
            required: true,
            maxlength: 20,
          }, //贴现率
          {
            type: 'date',
            label: '贴现日期',
            prop: 'discountDate',
            clearable: true,
            required: true,
          }, //贴现日期
          {
            type: 'input',
            label: '预计贴现息',
            prop: 'forecastDiscountRate',
            clearable: true,
          }, //预计贴现息
          {
            type: 'input',
            label: '实际贴现息',
            prop: 'actualDiscountRate',
            clearable: true,
            required: true,
            maxlength: 20,
          }, //实际贴现息
          {
            type: 'input',
            label: '贴息承担方',
            prop: 'discountAfford',
            clearable: true,
            required: true,
            maxlength: 20,
          }, //贴息承担方
          {
            type: 'input',
            span: 24,
            label: this.$t('tFundCreditLetter.column.summary'),
            prop: 'summary',
            maxlength: 256,
            clearable: true,
            disabled: false,
            required: true,
          }, //摘要,以上是申请信息
        ];
      },
      rules() {
        return {};
      },
    },

    mounted() {
      this.formData.applyUserId = this.userInfo.userCode;
      this.formData.applyUserName = this.userInfo.userName;
      this.getCompany();
    },
    methods: {
      handleChange(v, prop) {
        if (prop == 'businessCompanyCode') {
          this.formData.businessCompanyCode = v[prop];
          this.resetParter();
          this.changeCompany(v[prop]);
        } else if (prop == 'businessDepartmentCode') {
          this.formData.businessDepartmentCode = v[prop];
          this.resetParter();
          if (v[prop])
            this.formData.businessDepartmentName = this.departmentOptions.find(
              (it) => it.value == v[prop]
            ).label;
          this.$emit('updatePayment', this.formData);
        } else if (prop == 'currencyCode') {
          this.changeCurrency(v[prop]);
        } else if (prop == 'applyExchangeRateDate') {
          this.getRate();
        } else if (prop == 'applyExchangeRate') {
          this.exceApplyClStandardAmount();
        } else if (prop == 'partnerCode') {
          this.$emit('updatePayment', this.formData);
        } else if (prop == 'latestShipDate' || prop == 'usanceDaysNumber') {
          if (!this.formData.latestShipDate) return;
          let estimatedPayDate = XEUtils.getWhatDay(
            this.formData.latestShipDate,
            this.formData.usanceDaysNumber
          ); //预计付汇日=最迟装期+远期天数
          this.formData.estimatedPayDate = XEUtils.toDateString(estimatedPayDate, 'yyyy-MM-dd');
        } else if (prop == 'applyBranchCode') {
          let obj = { ...v[prop] };
          this.changeApplyBranchCode(obj);
        } else if (prop == 'clType') {
          if (v[prop] == '002') {
            // 选择国内信用证，自动带出经营性质为内贸
            this.formData.importExportNature = '002';
            //国内信用证，默认币种人民币
            // this.formData.currencyCode = this.$globalVar.currency.code
            // this.formData.currencyName = this.$globalVar.currency.name
          } else {
            this.formData.importExportNature = '';
            //国际信用证，默认币种美元
            this.formData.currencyCode = this.$globalVar.currency.forgeinCode;
          }
          this.changeCurrency(this.formData.currencyCode);
        }
      },
      // 变更开证申请银行
      changeApplyBranchCode(obj) {
        if (obj && obj[0]) {
          this.formData.applyBranchCode = obj[0].branchCode;
          this.formData.applyBranchName = obj[0].branchName;
          this.formData.applyBankAccountNum = obj[0].bankAccountNum;
          this.formData.marginRate = obj[0].clMarginRate || ''; //开证保证金比例
          this.formData.clMarginRate = obj[0].clMarginRate || ''; //开证申请保证金比例
          this.formData.clIssueCostRate = obj[0].clIssueCostRate || ''; //开证申请开证费用比例
          this.formData.clAcceptanceCostRate = obj[0].clAcceptanceCostRate || ''; //开证申请承兑费用比例

          this.formData.branchCode = obj[0].branchCode;
          this.formData.branchName = obj[0].branchName;
          this.formData.marginPayAccount = obj[0].bankAccountNum;
          this.formData.marginPayAccountName = obj[0].bankAccountName;
          //ASC17-国内信用证保证金账户 ASC18-国际信用证保证金账户
          if (
            (this.formData.clType == '002' && obj[0].secondaryClassCode == 'ASC17') ||
            (this.formData.clType == '001' && obj[0].secondaryClassCode == 'ASC18')
          ) {
            this.formData.marginReceiveAccount = obj[0].bankAccountNum;
            this.formData.marginReceiveAccountName = obj[0].bankAccountName;
          } else {
            this.formData.marginReceiveAccount = '';
            this.formData.marginReceiveAccountName = '';
          }
          this.calCost();
        } else {
          this.formData.applyBranchCode = '';
          this.formData.applyBranchName = '';
          this.formData.applyBankAccountNum = '';
          this.formData.marginRate = ''; //开证保证金比例
          this.formData.clMarginRate = ''; //开证申请保证金比例
          this.formData.clIssueCostRate = ''; //开证申请开证费用比例
          this.formData.clAcceptanceCostRate = ''; //开证申请承兑费用比例

          // “信用证开证”页“保证金转入银行”字段   银行账号只能选择二级属性为“国内信用证保证金账户”或“国际信用证保证金账户”的银行账户
          this.formData.branchCode = '';
          this.formData.branchName = '';
          this.formData.marginPayAccount = '';
          this.formData.marginPayAccountName = '';
          this.formData.applyMarginAmount = '';
          this.formData.issueCost = '';
          this.formData.acceptanceCost = '';
          this.formData.marginReceiveAccount = '';
          this.formData.marginReceiveAccountName = '';
        }
      },
      // 重置受益人
      resetParter() {
        this.formData.partnerCode = '';
        this.formData.partnerName = '';
      },
      // 计算银行比例费用
      calCost() {
        this.formData.applyMarginAmount = this.formData.clMarginRate
          ? this.$cal.calCommon(
              this.$cal.calCommon(this.formData.applyClAmount, this.formData.clMarginRate, '*'),
              100,
              '/',
              'amount'
            )
          : '';
        this.formData.issueCost = this.formData.clIssueCostRate
          ? this.$cal.calCommon(
              this.$cal.calCommon(this.formData.applyClAmount, this.formData.clIssueCostRate, '*'),
              100,
              '/',
              'amount'
            )
          : '';
        this.formData.acceptanceCost = this.formData.clAcceptanceCostRate
          ? this.$cal.calCommon(
              this.$cal.calCommon(
                this.formData.applyClAmount,
                this.formData.clAcceptanceCostRate,
                '*'
              ),
              100,
              '/',
              'amount'
            )
          : '';
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          BASE_API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyOptions = selectStatus.data.data;
        }
      },
      //业务部门
      initDepartment() {
        this.$axios
          .post(BASE_API.LIST_DEPARTMENT_API + '/' + this.formData.businessCompanyCode)
          .then((res) => {
            if (0 == res.data.code) {
              this.departmentOptions = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      changeCompany(val) {
        this.departmentOptions = [];
        this.formData.businessCompanyName = val
          ? this.companyOptions.find((it) => it.value == val).label
          : this.formData.businessCompanyName;
        this.formData.businessDepartmentCode = !val ? this.formData.businessDepartmentCode : '';
        this.formData.businessDepartmentName = !val ? this.formData.businessDepartmentName : '';
        this.formData.businessDepartmentName = !val ? this.formData.businessDepartmentName : '';
        if (val) {
          this.changeApplyBranchCode();
          this.$baseRequest.getLedger(val).then((res) => {
            if (res.length > 0) {
              //如果换公司，则币种都默认变化
              this.formData.currencyCode = res[0].currencyCode;
              this.formData.currencyName = res[0].currencyName;
              this.formData.companyCurrencyCode = res[0].currencyCode;
              this.formData.companyCurrencyName = this.$baseRequest.getDictValueByType(
                'all_currency',
                this.formData.companyCurrencyCode
              );
              this.getRate();
            } else {
              //没有查询到公司账套
              this.formData.currencyCode = null;
              this.formData.currencyName = null;
              this.formData.companyCurrencyCode = null;
              this.formData.companyCurrencyName = null;
              this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
            }
          });
          this.$emit('updatePayment', this.formData);
        } else {
          val = this.formData.businessCompanyCode;
        }
        this.companyOptions.find((item) => {
          if (item.value === val || !val) {
            this.initDepartment();
          }
        });
      },
      //切换币别
      changeCurrency(val) {
        if (!val) return;
        this.formData.currencyName = this.$baseRequest.getDictValueByType('all_currency', val);
        this.formData.currencyCode = val;
        this.$emit('updatePayment', this.formData);
        this.getRate();
      },
      // 获取汇率
      getRate() {
        // let taxRate;
        if (
          this.formData.currencyCode &&
          this.formData.companyCurrencyCode &&
          this.formData.currencyCode === this.formData.companyCurrencyCode
        ) {
          this.formData.applyExchangeRate = 1;
          this.exceApplyClStandardAmount();
        } else if (this.formData.currencyCode && this.formData.companyCurrencyCode) {
          this.getTaxRate();
        }
      },

      //获取汇率
      getTaxRate() {
        if (this.formData.currencyCode || this.formData.companyCurrencyCode) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: this.formData.currencyCode,
            toCurrencyCode: this.formData.companyCurrencyCode,
            exchangeDate: this.$baseRequest.getBeginOfMonth(this.formData.applyExchangeRateDate),
            exchangeType: this.formData.exchangeType,
          };
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.formData.applyExchangeRate = res.positiveRate;
              this.exceApplyClStandardAmount();
            } else {
              this.formData.applyExchangeRate = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      //计算开证金额本位币
      exceApplyClStandardAmount() {
        let applyClStandardAmount = this.$cal.calCommon(
          this.formData.applyExchangeRate,
          this.formData.applyClAmount,
          '*',
          'amount'
        );
        this.formData.applyClStandardAmount = applyClStandardAmount;
      },
      eleEstimatedPayDate() {
        this.$nextTick(() => {
          if (this.formData.latestShipDate && this.formData.usanceDaysNumber) {
            let date = new Date(this.formData.latestShipDate);
            date.setDate(date.getDate() + this.formData.usanceDaysNumber * 1);
            this.formData.estimatedPayDate = XEUtils.toDateString(date, 'yyyy-MM-dd');
            this.$forceUpdate();
          }
        });
      },
      getDetail(allDetail) {
        this.formData = allDetail;
        this.changeCompany();
      },
      changeDepartment(val) {
        this.formData.businessDepartmentCode = val;
        this.formData.businessDepartmentName = this.departmentOptions.find(
          (it) => it.value == val
        ).label;
      },
      //切换开证银行
      changeBank(val) {
        let bankinfo = this.bankList.find((it) => it.bankCode == val);
        this.formData.applyBranchName = bankinfo.bankName + bankinfo.bankBranch;
      },
      // 设置受益人/合作伙伴
      setPartnerCode(row) {
        this.formData.partnerCode = row[0].partnerCode;
        this.formData.partnerName = row[0].partnerZhName;
        this.$emit('setPartnerCode', this.formData.partnerCode);
      },
      // 设置开证银行
      setBank(row) {
        this.formData.applyBranchCode = row[0].branchCode;
        this.formData.applyBranchName = row[0].branchName;
      },
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        return new Promise((resolve, reject) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              resolve(this.formData);
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .widthStyle {
    width: 100%;
  }
</style>
